import {otsBaseApi} from "../../ots-api";
import {
  MeterFlowVolume,
  MeterFlowVolumeSearchCriteria,
  MeterFlowVolumeTotalSearchCriteria
} from "../../../model/meter-flow-volume";
import {MeterFlowVolumeTotal, TemporalMeterFlowVolumeTotalMatrix} from "../../../model/meter-flow-volume-total";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["MeterFlowVolumes"]});

const meterFlowVolumeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchMeterFlowVolumes: builder.query<
      MeterFlowVolume[],
      MeterFlowVolumeSearchCriteria
    >({
      query: (criteria) => ({
        url: `/meter-flow-volumes/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "MeterFlowVolumes", id} as const)),
            {type: "MeterFlowVolumes", id: "LIST"}
          ];
        } else {
          return [{type: "MeterFlowVolumes", id: "LIST"}];
        }
      },
    }),
    getMeterFlowVolume: builder.query<MeterFlowVolume, string>({
      query: (id) => ({
        url: `/meter-flow-volumes/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "MeterFlowVolumes", id}]
    }),
    createMeterFlowVolume: builder.mutation<MeterFlowVolume, Partial<MeterFlowVolume>>({
      query: (mapping) => ({
        url: "/meter-flow-volumes",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "MeterFlowVolumes", id: "LIST"}]
    }),
    updateMeterFlowVolume: builder.mutation<MeterFlowVolume, Partial<MeterFlowVolume>>({
      query: (mapping) => ({
        url: "/meter-flow-volumes",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "MeterFlowVolumes", id}]
    }),
    deleteMeterFlowVolume: builder.mutation<void, Partial<MeterFlowVolume>>({
      query: (mapping) => ({
        url: "/meter-flow-volumes",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "MeterFlowVolumes", id}]
    }),
    searchMeterFlowVolumeTotals: builder.query<
      MeterFlowVolumeTotal[],
      MeterFlowVolumeTotalSearchCriteria
    >({
      query: (criteria) => ({
        url: `/meter-flow-volumes/meter-totals`,
        method: 'POST',
        body: criteria,
      }),
    }),
    searchMeterFlowVolumeTotalsByDate: builder.query<
      TemporalMeterFlowVolumeTotalMatrix,
      MeterFlowVolumeTotalSearchCriteria
    >({
      query: (criteria) => ({
        url: `/meter-flow-volumes/meter-totals-by-date`,
        method: 'POST',
        body: criteria,
      }),
    }),
  })
});

export const {
  useSearchMeterFlowVolumesQuery,
  useGetMeterFlowVolumeQuery,
  useCreateMeterFlowVolumeMutation,
  useUpdateMeterFlowVolumeMutation,
  useDeleteMeterFlowVolumeMutation,
  useSearchMeterFlowVolumeTotalsQuery,
  useSearchMeterFlowVolumeTotalsByDateQuery,
} = meterFlowVolumeApi;
